(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
      
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pepe-about-2026"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-instagram-carousel')) {
    customElements.define('pm-instagram-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.pm-instagram-track');
        const slides = Array.from(track.children);
        const controls = this.querySelector('.pm-instagram-controls');
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        const position = this.querySelector('[data-position]');
        let active = 0;
        const update = () => {
          const left = track.getBoundingClientRect().left;
          active = slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? index : best, 0);
          track.style.height = `${slides[active].offsetHeight}px`;
          previous.disabled = active === 0;
          next.disabled = active === slides.length - 1;
          position.textContent = `${active + 1} / ${slides.length}`;
          slides.forEach((slide, index) => {
            slide.inert = index !== active;
            if (index !== active) slide.querySelectorAll('video').forEach(video => video.pause());
          });
        };
        const move = index => {
          index = Math.max(0, Math.min(slides.length - 1, index));
          const distance = slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left;
          track.scrollBy({ left: distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        slides.forEach(slide => slide.querySelectorAll('img').forEach(img => img.addEventListener('load', update, options)));
        controls.hidden = slides.length < 2;
        previous.addEventListener('click', () => move(active - 1), options);
        next.addEventListener('click', () => move(active + 1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = slides.indexOf(event.target.closest('.pm-instagram-slide'));
          if (index >= 0) move(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          track.scrollLeft = active * track.clientWidth;
          update();
        });
        this.resizeObserver.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-licencias-cotizacion"] && !Shopify.designMode) return;
  try {
    
function initializeNailoong(root){if(root.dataset.pmnlReady)return;root.dataset.pmnlReady='true';const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();const search=root.querySelector('[data-pmnl-search]');const filter=root.querySelector('[data-pmnl-filter]');const cards=[...root.querySelectorAll('[data-pmnl-card]')];function update(){let count=0;const term=normalize(search.value.trim());cards.forEach(card=>{const match=normalize(card.dataset.search).includes(term)&&(filter.value==='all'||card.dataset.group===filter.value);card.hidden=!match;if(match)count++;});root.querySelector('[data-pmnl-count]').textContent=count;root.querySelector('[data-pmnl-empty]').hidden=count!==0;}search.addEventListener('input',update);filter.addEventListener('change',update);update();root.addEventListener('click',event=>{const open=event.target.closest('[data-pmnl-open]');if(open){const dialog=root.querySelector('[data-pmnl-dialog="'+open.dataset.pmnlOpen+'"]');dialog.showModal();}const close=event.target.closest('[data-pmnl-close]');if(close)close.closest('dialog').close();if(event.target.matches('dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});}document.querySelectorAll('[data-pmnl]').forEach(initializeNailoong);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pmnl]').forEach(initializeNailoong));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-licencias-preview"] && !Shopify.designMode) return;
  try {
    
function initializeNailoong(root){if(root.dataset.pmnlReady)return;root.dataset.pmnlReady='true';const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();const search=root.querySelector('[data-pmnl-search]');const filter=root.querySelector('[data-pmnl-filter]');const cards=[...root.querySelectorAll('[data-pmnl-card]')];function update(){let count=0;const term=normalize(search.value.trim());cards.forEach(card=>{const match=normalize(card.dataset.search).includes(term)&&(filter.value==='all'||card.dataset.group===filter.value);card.hidden=!match;if(match)count++;});root.querySelector('[data-pmnl-count]').textContent=count;root.querySelector('[data-pmnl-empty]').hidden=count!==0;}search.addEventListener('input',update);filter.addEventListener('change',update);update();root.addEventListener('click',event=>{const open=event.target.closest('[data-pmnl-open]');if(open){const dialog=root.querySelector('[data-pmnl-dialog="'+open.dataset.pmnlOpen+'"]');dialog.showModal();}const close=event.target.closest('[data-pmnl-close]');if(close)close.closest('dialog').close();if(event.target.matches('dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});}document.querySelectorAll('[data-pmnl]').forEach(initializeNailoong);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pmnl]').forEach(initializeNailoong));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-noticias"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pm-news-carousel')){
  customElements.define('pm-news-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.pmReady)return;
      const track=this.querySelector('[data-news-track]');
      if(!track)return;
      const cards=Array.from(track.children);
      if(!cards.length)return;
      this.pmReady=true;
      this.pmAbort=new AbortController();
      const options={signal:this.pmAbort.signal};
      const controls=this.querySelector('.pm-news__controls');
      const previous=this.querySelector('[data-news-prev]');
      const next=this.querySelector('[data-news-next]');
      const position=this.querySelector('[data-news-position]');
      const reduce=matchMedia('(prefers-reduced-motion:reduce)');
      const update=()=>{
        const frame=track.getBoundingClientRect();
        const visible=cards.map((card,index)=>({box:card.getBoundingClientRect(),index})).filter(item=>item.box.right>frame.left+4&&item.box.left<frame.right-4);
        const max=track.scrollWidth-track.clientWidth;
        controls.hidden=max<4;
        previous.disabled=track.scrollLeft<4;
        next.disabled=track.scrollLeft>=max-4;
        if(visible.length){
          const first=visible[0].index+1,last=visible[visible.length-1].index+1;
          position.textContent=first+(last>first?'–'+last:'')+' / '+cards.length;
        }
      };
      const schedule=()=>{
        if(this.pmFrame)cancelAnimationFrame(this.pmFrame);
        this.pmFrame=requestAnimationFrame(update);
      };
      const move=direction=>{
        const gap=parseFloat(getComputedStyle(track).columnGap)||0;
        track.scrollBy({left:direction*(cards[0].getBoundingClientRect().width+gap),behavior:reduce.matches?'auto':'smooth'});
      };
      previous.addEventListener('click',()=>move(-1),options);
      next.addEventListener('click',()=>move(1),options);
      track.addEventListener('keydown',event=>{
        if(event.target!==track)return;
        if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}
        if(event.key==='Home'||event.key==='End'){event.preventDefault();track.scrollTo({left:event.key==='Home'?0:track.scrollWidth,behavior:reduce.matches?'auto':'smooth'});}
      },options);
      track.addEventListener('scroll',schedule,{...options,passive:true});
      this.pmObserver=new ResizeObserver(schedule);
      this.pmObserver.observe(track);
      update();
    }
    disconnectedCallback(){this.pmAbort?.abort();this.pmObserver?.disconnect();if(this.pmFrame)cancelAnimationFrame(this.pmFrame);this.pmReady=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-relaciones-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pm-relations-gallery')){
  customElements.define('pm-relations-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.pmReady)return;
      this.pmReady=true;
      this.pmAbort=new AbortController();
      const options={signal:this.pmAbort.signal};
      const track=this.querySelector('[data-relations-track]');
      const cards=Array.from(track.children);
      const controls=this.querySelector('.pm-relations__controls');
      const previous=this.querySelector('[data-relations-prev]');
      const next=this.querySelector('[data-relations-next]');
      const position=this.querySelector('[data-relations-position]');
      const reduce=matchMedia('(prefers-reduced-motion:reduce)');
      const update=()=>{
        const frame=track.getBoundingClientRect();
        const active=cards.reduce((best,card,index)=>Math.abs(card.getBoundingClientRect().left-frame.left)<Math.abs(cards[best].getBoundingClientRect().left-frame.left)?index:best,0);
        const max=track.scrollWidth-track.clientWidth;
        controls.hidden=max<4;
        previous.disabled=track.scrollLeft<4;
        next.disabled=track.scrollLeft>=max-4;
        const visible=Math.max(1,Math.round((track.clientWidth+parseFloat(getComputedStyle(track).columnGap))/(cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap))));
        const last=Math.min(cards.length,active+visible);
        position.textContent=(active+1)+(last>active+1?'–'+last:'')+' / '+cards.length;
        track.querySelectorAll('video').forEach(video=>{
          const box=video.getBoundingClientRect();
          if(box.right<=frame.left+4||box.left>=frame.right-4)video.pause();
        });
      };
      const move=direction=>{
        const width=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
        track.querySelectorAll('video').forEach(video=>video.pause());
        track.scrollBy({left:direction*width,behavior:reduce.matches?'auto':'smooth'});
      };
      previous.addEventListener('click',()=>move(-1),options);
      next.addEventListener('click',()=>move(1),options);
      track.addEventListener('keydown',event=>{
        if(event.target!==track)return;
        if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}
      },options);
      track.addEventListener('scroll',update,{...options,passive:true});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)track.querySelectorAll('video').forEach(video=>video.pause());},options);
      this.pmObserver=new ResizeObserver(update);
      this.pmObserver.observe(track);
      update();
    }
    disconnectedCallback(){this.pmAbort?.abort();this.pmObserver?.disconnect();this.pmReady=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
